import { h } from '../lib/dom.js';
import { getState, setSilent } from '../store.js';
import { cancelImportKey, saveImportKey, validateImportPhraseBlur } from '../actions.js';

export function renderImportKeyModal() {
  const s = getState();
  if (!s.showImportKey) return null;
  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, 'Import private key'),
      h('textarea', {
        placeholder: 'Enter your 24-word recovery phrase', class: 'mono textarea-tall',
        oninput: (e) => setSilent({ importText: e.target.value }),
        onblur: validateImportPhraseBlur
      }, s.importText),
      h('div', { class: 'field-error' }, s.importError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelImportKey }, 'Cancel'),
        h('button', { class: 'btn btn-primary', onclick: saveImportKey }, 'Import')
      ])
    ])
  ]);
}
